<template>
  <section>
      <!-- The Modal -->
      <div id="myModal" class="c-modal drive_through_modal" :style="{ display: show ? 'block' : 'none' }">
        <div class="c-modal__dialog c-modal__dialog--center">
          <!-- Modal content -->
          <div class="c-modal__content">
            <div class="l-situation">
              <div class="c-box-situation mb-10">
                <div class="c-box-situation__head">
                  <span class="box-center">{{mobileOrderConfig && mobileOrderConfig.parkAndPickupAreaName}}</span>
                </div>
                <div class="c-box-situation__body">
                  <div class="mb-10">
                    <img :src="getImgSrc(mobileOrderConfig && mobileOrderConfig.parkAndPickupAreaImage)" alt="" width="100%" style="width:100%">
                    {{mobileOrderConfig && mobileOrderConfig.parkAndPickupAreaText}}
                  </div>
                  <div class="d-flex">
                    <img :src="getImgSrc(mobileOrderConfig && mobileOrderConfig.parkAndPickupNoticeImage)" v-if="mobileOrderConfig && mobileOrderConfig.parkAndPickupNoticeImage" alt="" width="82" style="width: 82px">
                    <div v-if="mobileOrderConfig && mobileOrderConfig.parkAndPickupNoticeText">
                      <span>ご注意：</span><br />
                      {{mobileOrderConfig && mobileOrderConfig.parkAndPickupNoticeText}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="l-situation__foot">
                <a href="#" class="c-btn-close" id="close_modal" @click.prevent="onClose('parkandpickup')">
                  <img src="/assets/images/icon/icon-close-black.svg" alt="" />閉じる
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { eventBus, Common } from "../common/common";
import { getMobileOrderConfig } from "../store/firestore";
import { IMG_HOST } from "../config/const";

export default Vue.extend({
  name: 'parkandpickup-modal',
  props: ['show', 'onClose'],
  async created(){
    const mobileOrderConfig = await getMobileOrderConfig();
    this.mobileOrderConfig = mobileOrderConfig;
    eventBus.$on("answerCall", function(){
      this.show = false;
    });
  },
  data() {
    return {
      mobileOrderConfig: null
    }
  },
  methods: {
    getImgSrc (src) {
      if (!src) { return '/assets/images/aeontown-noimg.png' }
      if (src.indexOf('http') != -1) {
        return src;
      }
      return IMG_HOST + src;
    },
  }
})
</script>